class DataSharingHelper {
  public static RoundFee(fee: number) {
    return Math.round(fee * 10000) / 10000;
  }

  public static CapitalizeString(str: string) {
    return str[0].toUpperCase() + str.slice(1);
  }
}

export default DataSharingHelper;



// WEBPACK FOOTER //
// ./src/modules/shared/helpers/DataSharingHelper.tsx